import { render } from "./user.vue?vue&type=template&id=bb67c656"
const script = {}

import exportComponent from "/Users/lily/Documents/7pa/qpyx-webs-hongkong-buff/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__